import { useTreatments } from '@splitsoftware/splitio-react';

export const useFeatureSplit = (splitName: string) => {
  const {
    [splitName]: { treatment, config },
  } = useTreatments([splitName]);

  return {
    config,
    treatment,
    isTreatmentActive: treatment === 'on',
  };
};
